/**
 * AttivitaDettaglioPage - Page Shell
 * Form attività (Drawer)
 */

import { useParams, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import { AttivitaForm } from "@/features/attivita";

export default function AttivitaDettaglioPage() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const [open, setOpen] = useState(true);

  // Reindirizza se chiuso
  useEffect(() => {
    if (!open) {
      navigate("/operativo/attivita");
    }
  }, [open, navigate]);

  return (
    <ActivityForm
      id={id}
      open={open}
      onOpenChange={setOpen}
      onSaved={() => {}}
    />
  );
}
